import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';


const Footer = () => {
    const navigate = useNavigate();

    return (
        <footer className="footer">
            <div className="footer-links">
                    <button onClick={() => navigate('/platform')}>Platform</button>
                    <button onClick={() => navigate('/solutions')}>Solutions</button>
                    <button onClick={() => navigate('/resources')}>Resources</button>
                    <button onClick={() => navigate('/pricing')}>Pricing</button>
                    <button onClick={() => navigate('/about')}>About Us</button>
                    <button onClick={() => navigate('/contact')}>Contact Us</button>
                    <button onClick={() => navigate('/cards')} className="sign-up">Create a Card</button>
                    <button onClick={() => navigate('/login')} className="login">Login</button>
            </div>
            <div className="footer-social">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook"></i>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-twitter"></i>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-youtube"></i>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin"></i>
                </a>
            </div>
            <p>&copy; 2024 Digicard. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
